import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Typography } from "@mui/material";

function TicketsMessageError() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={10}>
      <ErrorOutlineIcon color="error" fontSize="large" />
      <Typography variant="body2" color="error" mt={2}>
        Ocorreu um erro ao carregar as ordens de serviço. Por favor, tente novamente mais tarde.
      </Typography>
    </Box>
  );
}

export default TicketsMessageError;
